define('constants/smsConversationReviewedStatus',[],() => {
    return Object.freeze({
        All: 0,
        New: 1,
        Reviewed: 2
    });
});
